module.exports = __webpack_public_path__ + "img/service2-2.7ab6b463.webp";